let storage;

try {
    storage = window.localStorage;
} catch (error) {
    storage = {
        disabled: true,
    };
}

const exportStorage = storage;

export default exportStorage;



// WEBPACK FOOTER //
// ./static_source/js/fallback_storage.js